"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const Event = {
    fragments: {
        schedule: {},
        location: {},
        performances: {},
        ticketTypes: {},
        holds: {},
        upgrades: {},
        promotions: {},
        customFields: {},
        fees: {},
        exchange: {},
        metrics: {},
        webFlowEntity: {},
        artists: {},
        analytics: {},
        guestList: {},
        purchasePortalPromotions: {},
    },
};
Event.fragments = {
    schedule: (0, client_1.gql) `
    fragment EventSchedule on Event {
      schedule {
        announceAt
        ticketsAt
        ticketsEndAt
        startsAt
        endsAt
      }
    }
  `,
    location: (0, client_1.gql) `
    fragment Location on Event {
      location {
        address1
        address2
        city
        state
        zip
        country
        phone
      }
    }
  `,
    performances: (0, client_1.gql) `
    fragment Performances on Event {
      performances {
        _id
        name
        headliningArtistIds
        openingArtistIds
        venueId
        venueStageId
        price
        posterImageUrl
        videoLink
        vimeoLink
        songLink
        schedule {
          doorsAt
          startsAt
          endsAt
          _id
        }
      }
    }
  `,
    ticketTypes: (0, client_1.gql) `
    fragment TicketTypes on Event {
      ticketTypes {
        _id
        name
        totalQty
        remainingQty
        purchaseLimit
        performanceIds
        visible
        description
        rollFees
        values
        dayIds
        isTicketSharing
        tiers {
          _id
          name
          price
          startsAt
          endsAt
          totalQty
          remainingQty
          isActive
        }
      }
    }
  `,
    holds: (0, client_1.gql) `
    fragment TicketHolds on Event {
      holds {
        _id
        name
        qty
        ticketTypeId
        ticketType
        totalHeld
        totalCheckedIn
        totalReleased
        totalOutstanding
      }
    }
  `,
    guestList: (0, client_1.gql) `
    fragment EventGuestList on Event {
      guestList {
        _id
        firstName
        lastName
        createdAt
        checkIns {
          startsAt
          checkedIn
          checkedInAt
        }
      }
    }
  `,
    upgrades: (0, client_1.gql) `
    fragment EventUpgrades on Event {
      upgrades {
        _id
        name
        price
        totalQty
        remainingQty
        purchaseLimit
        complimentary
        complimentaryWith
        complimentaryQty
        ticketTypeIds
        imageUrl
        description
        isAddOnsSharing
        rollFees
        visible
      }
    }
  `,
    promotions: (0, client_1.gql) `
    fragment EventPromotions on Event {
      promotions {
        _id
        code
        type
        totalQty
        remainingQty
        ticketTypeIds
        upgradeIds
        active
        startsAt
        endsAt
        useLimit
        overRideMax
        overRideMaxUpg
        discountType
        discountValue
        appliesTo
      }
    }
  `,
    customFields: (0, client_1.gql) `
    fragment EventCustomFields on Event {
      customFields {
        _id
        label
        type
        minLength
        maxLength
        minValue
        maxValue
        options
        required
        active
      }
    }
  `,
    fees: (0, client_1.gql) `
    fragment Fees on Event {
      fees {
        _id
        name
        orgId
        eventId
        type
        value
        appliedTo
        appliedBy
        minAppliedToPrice
        maxAppliedToPrice
        filters
        createdBy
        createdAt
        updatedBy
        updatedAt
        disabled
        paymentMethods
      }
    }
  `,
    artists: (0, client_1.gql) `
    fragment Artists on Event {
      artists {
        _id
        name
        genres
        socialAccounts {
          _id
          platform
          link
        }
        pressKits {
          _id
          title
          description
          posterImageUrls
          links {
            platform
            link
          }
        }
      }
    }
  `,
    exchange: (0, client_1.gql) `
    fragment TicketExchange on Event {
      exchange {
        allowed
        percent
      }
    }
  `,
    metrics: (0, client_1.gql) `
    fragment Metrics on Event {
      metrics {
        lifeTimeTicketsPurchased
        lifeTimeTicketsRefunded
        lifeTimeUpgradesPurchased
        lifeTimeUpgradesRefunded
        lifeTimeValue
        lifeTimeValueRefunded
      }
    }
  `,
    webFlowEntity: (0, client_1.gql) `
    fragment WebFlowEntity on Event {
      webFlowEntity {
        _id
        name
        selloutId
        entityType
        alwaysPublishTo
        webFlowIds {
          webFlowSiteId
          webFlowEntityId
          slug
          webFlowSite {
            name
            webFlowId
            enabled
            previewUrl
            domains {
              name
              lastPublishedAt
            }
            createdAt
            updatedAt
          }
        }
      }
    }
  `,
    analytics: (0, client_1.gql) `
    fragment Analytics on Event {
      analytics {
        label
        type
        interval
        intervalOptions
        coordinates {
          x
          y
        }
        segments {
          label
          type
          coordinates {
            x
            y
          }
        }
      }
    }
  `,
    purchasePortalPromotions: (0, client_1.gql) `
    fragment EventPromotions on Event {
      promotions {
        _id
        type
        code
        totalQty
        remainingQty
        ticketTypeIds
        upgradeIds
        active
        startsAt
        endsAt
        useLimit
        overRideMax
        overRideMaxUpg
        discountType
        discountValue
        appliesTo
      }
    }
  `,
};
exports.default = Event;
// Event.fragments.event = gql`
//   fragment Event on Event {
//     _id
//     orgId
//     type
//     name
//     subtitle
//     description
//     posterImageUrl
//     venueId
//     createdAt
//     publishable
//     ...EventSchedule
//     ...Location
//     ...Performances
//     ...TicketTypes
//     ...TicketHolds
//     ...EventUpgrades
//     ...EventPromotions
//     ...EventCustomFields
//     ...TicketExchange
//     ...Fees
//   }
//   ${Event.fragments.schedule}
//   ${Event.fragments.location}
//   ${Event.fragments.performances}
//   ${Event.fragments.ticketTypes}
//   ${Event.fragments.holds}
//   ${Event.fragments.upgrades}
//   ${Event.fragments.promotions}
//   ${Event.fragments.customFields}
//   ${Event.fragments.exchange}
//   ${Event.fragments.fees}
// `,
//# sourceMappingURL=event.fragment.js.map